import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/pages/home/home.component';
import { MarketingAgencyComponent } from './components/pages/marketing-agency/marketing-agency.component';
import { DigitalMarketingComponent } from './components/pages/digital-marketing/digital-marketing.component';
import { BusinessSolutionsComponent } from './components/pages/business-solutions/business-solutions.component';
import { AboutComponent } from './components/pages/about/about.component';
import { ServicesComponent } from './components/pages/services/services.component';
import { ServiceDetailsComponent } from './components/pages/service-details/service-details.component';
import { ProjectsComponent } from './components/pages/projects/projects.component';
import { ProjectDetailsComponent } from './components/pages/project-details/project-details.component';
import { BlogComponent } from './components/pages/blog/blog.component';
import { BlogDetailsComponent } from './components/pages/blog-details/blog-details.component';
import { FeaturesComponent } from './components/pages/features/features.component';
import { TeamComponent } from './components/pages/team/team.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';
import { PartnerComponent } from './components/pages/partner/partner.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { FaqComponent } from './components/pages/faq/faq.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { CustomersComponent } from './components/pages/customers/customers.component';
import { TestimonialsComponent } from './components/pages/testimonials/testimonials.component';
import { ReturnpolicyComponent } from './components/pages/returnpolicy/returnpolicy.component';
import { TermsandconditionComponent } from './components/pages/termsandcondition/termsandcondition.component';
import { PrivacyComponent } from './components/pages/privacy/privacy.component';

const routes: Routes = [
    {path: '', component: HomeComponent},
    {path: 'about', component: AboutComponent},
    {path: 'services', component: ServicesComponent},
    {path: 'blog/:id', component: BlogComponent},
    {path: 'blog/:name/:id', component: BlogDetailsComponent},
    {path: 'features', component: FeaturesComponent},
    {path: 'team', component: TeamComponent},
    {path: 'pricing', component: PricingComponent},
    {path: 'partner', component: PartnerComponent},
    {path: 'customers/:id', component: CustomersComponent},
    {path: 'faq', component: FaqComponent},
    {path: 'contact', component: ContactComponent},
    {path: 'testimonials', component: TestimonialsComponent},
    {path: 'refund', component: ReturnpolicyComponent},
    {path: 'terms', component: TermsandconditionComponent},
    {path: 'privacy', component: PrivacyComponent},
    // Here add new pages component

    //http://localhost:4200/

    {path: '**', component: NotFoundComponent} // This line will remain down from the whole pages component list
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }